export default "__VITE_ASSET__qUIqx7Z$__"